// console.log("----> add-to-Cart.js <-----");

async function getCartData() {
  let fetchData = await fetch('/cart.js');
  let responce = fetchData.json();
  return responce;
}

this.addToCartButtons = document.querySelectorAll(".add-to-cart");
const add = (event, data = "", dataItems = "", addToCartAction = 'drawer') => {
  console.log({
    event:event,
    data:data,
    dataItems: dataItems,
    addToCartAction: addToCartAction,
    currentTarget:event.currentTarget
  })

   console.log("dp",data);

  // document.querySelector('[loading-for-quickview]').style.display = 'block';
  //showCartNotification();
  // console.log("adddd", addToCartAction)
  /*if (event.currentTarget.nodeName != "BUTTON") {
      return;
    }*/
  let currentBtn = event.currentTarget;
  let items = [];
  let variantId, variantQuantity;
  if (currentBtn) {
    variantId = parseInt(currentBtn.dataset.variantId);
    variantQuantity = parseInt(currentBtn.dataset.quantity);
  }
  if (data != "") {
    var d = JSON.parse(data);
    variantId = d.id;
    variantQuantity = d.quantity
  }
  let item = {
    id: variantId,
    quantity: variantQuantity
  }
  items.push(item);
  let productObject = {
    'items': items
  };
  console.log(productObject);
  console.log("Adding Product to cart....");

  if (dataItems != '') {
    productObject = {
      'items': dataItems
    };
  }

 

  //Update Cart Ajax
  function updateCartAjax() {
    // console.log('cart data updating ....')
    // console.log(JSON.parse(document.getElementById("cartAjax").innerHTML))
    getCartData().then(function(data) {
      document.getElementById("cartAjax").innerHTML = JSON.stringify(data);
      // console.log('cart data Updated :)');
      // console.log(JSON.parse(document.getElementById("cartAjax").innerHTML))
    })
  }


  //Make Cart Product Array
  function catProductArray() {
    var cartItems = JSON.parse(document.getElementById("cartAjax").innerHTML).items,
        itemArray = {};
    itemArray['productQty'] = [];
    itemArray['productKey'] = [];
    itemArray['key'] = {};
    cartItems.forEach(function(element) {
      var item = `${element.id}/${element.quantity}`,
          itemKey = `${element.id}/${element.quantity}/${element.key}`;
      itemArray['productQty'].push(item)
      itemArray['productKey'].push(itemKey);
      itemArray['key'][element.id] = element.key;
    });
    return itemArray;
  }

  //Check product Already added in cart or not
  function checkProductsInCart(ItemArray) {
    var isAdded = false;
    // console.log("ItemArray :: ", ItemArray)
    for (var i = 0; i < ItemArray.length; i++) {
      var productId = ItemArray[i].id,
          quantity = ItemArray[i].quantity;
      // console.log(productId, quantity, catProductArray().productQty, catProductArray().productQty.indexOf(`${productId}/${quantity}`))
      if (catProductArray().productQty.indexOf(`${productId}/${quantity}`) == -1) {
        isAdded = true;
        break
      }
    }
    return isAdded;
  }

  function makeItemArray(items) {
    var dataArray = [];
    items.forEach(function(ele) {
      var tmp = `${ele.id}/${ele.quantity}`;
      if (catProductArray().productQty.indexOf(tmp) == -1) {
        // console.log(tmp, catProductArray().productQty, catProductArray().productQty.indexOf(tmp), catProductArray().productKey)
        var productdata = catProductArray().productKey[catProductArray().productQty.indexOf(tmp)].split('/'),
            tmpArray = {};
        tmpArray['id'] = productdata[0];
        tmpArray['quantity'] = productdata[2];
        dataArray.push(tmpArray)
      } else {
        dataArray.push(ele)
      }
    })
    return dataArray;
  }
  // console.log(checkProductsInCart(productObject.items))

  var catUrl = '/cart/add.js';
  //   if (checkProductsInCart(productObject.items) == true) {
  //     var tmpData = {};
  //     // console.log(catProductArray().key);
  //     tmpData['id'] = catProductArray().key[productObject.items[0].id];
  //     tmpData['quantity'] = productObject.items[0].quantity;

  //     // console.log("tmpData :: ", tmpData);

  //     productObject = tmpData
  //     var catUrl = '/cart/change.js';
  //   }
  console.log("Cart Url", catUrl);
  var JsonCurrentData = `${productObject.items[0].id}/${productObject.items[0].quantity}`;
  console.log(JsonCurrentData,productObject.items)

  //console.log(catUrl,productObject.items.id,"\n productObject ::",productObject,"\n dataItems :: ",dataItems,"\n items :: ",items)
  fetch(catUrl, {
    method: 'POST',
    headers: {
      'Accept': 'application/json, text/plain, */*',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(productObject)
  }).then((res) => { return res.json() })
  .then((response) => {
    console.log("Product added in to cart....");
    // document.querySelector('[loading-for-quickview]').style.display = 'none';
    console.log('success',response);
    if(addToCartAction == 'drawer'){
      document.getElementById('cart-icon-bubble').setAttribute('data-load-ajax',"true");
      document.getElementById('cart-icon-bubble').click();
    }
    if(addToCartAction == 'popup'){
      showCartNotification();
    }
    if(addToCartAction == 'page'){
      window.location.href = '/cart';
    }

    updateCartAjax();

  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

function querySelectorFunction() {
  //console.log("querySelectorFunction");
  document.querySelectorAll(".add-to-cart").forEach((addToCartBtn) => {
    // console.log("addToCartBtn",addToCartBtn);
    if(addToCartBtn.classList.contains('eventAdded') == false){
      addToCartBtn.classList.add("eventAdded");
      // console.log("enable_popup",enable_popup);
      //console.log("addToCartBtn :: ",addToCartBtn)
      addToCartBtn.addEventListener('click', event => add(event, "", "", window.enable_popup))
    }
  });
}

window.addToCart = add;
window.querySelectorFunction = querySelectorFunction;

querySelectorFunction();

const showCartNotification = () => {
  this.cartNotificationPopup = document.querySelector(".custom-model-main[data-cart-popup]");
  this.closeCartNotificationPopup = document.querySelector(".custom-model-inner .close-btn");
  this.closeCartNotificationPopup.addEventListener("click", closeNotificatioPopup);
  this.cartCount = this.cartNotificationPopup.querySelector("span.cartCount");
  this.cartBubbleCount = document.querySelector(".cartBubbleCount");
  this.cartTotal = this.cartNotificationPopup.querySelector(".total .price");
  fetch('/cart.js', {
    method: 'GET',
    headers: {
      'Accept': 'application/json, text/plain, */*',
      'Content-Type': 'application/json'
    },
  }).then((res) => { return res.json() })
  .then((response) => {
    if (this.cartCount) {
      this.cartCount.innerHTML = response.item_count;
    }
    if (this.cartBubbleCount) {
      this.cartBubbleCount.innerHTML = response.item_count;
    }
    if (response.item_count > 0) {
      this.cartNotificationPopup.querySelector(".noItemsMessage--main").style.display = "none";
      var scrollContent = this.cartNotificationPopup.querySelector(".cart-form.wrapper-cart");
      if (scrollContent.classList.contains("has-noItems")) {
        scrollContent.style.display = "block";
      }
      this.cartNotificationPopup.querySelector(".cart-des.des").style.display = "block";

      this.cartTotal.innerHTML = Shopify.formatMoney(response.total_price, window.money_format);
      this.cartItems(response.items);
      attachEvents();
      document.querySelector(".custom-model-main[data-quickView-popup]").classList.remove("model-open");
      this.cartNotificationPopup.classList.add("model-open");
    } else {
      //       this.PopupContent = this.cartNotificationPopup.querySelector(".cart-popup-content");
      this.PopupContent = this.cartNotificationPopup.querySelector(".noItemsMessage--main");
      this.PopupContent.style.display = "block";
      this.cartNotificationPopup.querySelector(".cart-form.wrapper-cart").classList.add("has-noItems");
      this.cartNotificationPopup.querySelector(".cart-form.wrapper-cart").style.display = "none";
      this.cartNotificationPopup.querySelector(".cart-des.des").style.display = "none";
      //       this.PopupContent.innerHTML = "";
      let emptyState = `<p class="alert alert-warning" data-translate="cart.general.empty">
Your shopping cart is empty.
</p>
<p class="cart-empty" data-translate="cart.general.continue_browsing_html">
<a href="/">Continue shopping</a>.
</p>`;
      this.PopupContent.innerHTML = emptyState;
    }
  })
  .catch((error) => {
    console.error('Error:', error);
    return false;
  });

  this.cartItems = (items) => {
    this.itemsContainer = this.cartNotificationPopup.querySelector(".cart-list");
    this.itemsContainer.innerHTML = "";
    let itemHTML = "";
    items.forEach((item, index) => {
      let itemKey = item.key;
      let itemTitle = item.title;
      let itemUrl = item.url;
      let itemPrice = Shopify.formatMoney(item.price, window.money_format);
      let itemQuantity = item.quantity;
      let itemLinePrice = Shopify.formatMoney(item.line_price, window.money_format);
      itemHTML += `<li>
<div class="details"> 
<div class="cart-thumb">
<a class="product-img" href="#">
<img src="${item.image}" alt="${item.title}">
</a>
</div>

<div class="cart-title">
<a href="${itemUrl}" class="product-name">
<span> ${itemTitle}</span> </a>
<div class="size">  
</div>
</div>
</div>

<div class="flex_row">           
<div class="cart-price">
<div class="price-box">
<span>
${itemPrice}
</span>
</div>
</div>

<div class="cart-quantity">
<div class="qty-group">
<a href="javascript:void(0);" data-key="${itemKey}" data-up-quantity="${itemQuantity - 1}" class="cart-qty-minus minus button">-</a>
<input type="text" data-qtt-id="quantity__${item.id}" data-quantity-input="" name="quantity" value="${itemQuantity}">
<a href="javascript:void(0);" data-key="${itemKey}" data-up-quantity="${itemQuantity + 1}" class="cart-qty-plus plus button">+</a>
</div>
</div>

<div class="cart-line-price">
<div class="price-box">
<span>
${itemLinePrice}
</span>
</div>
</div>                    

<div class="cart-remove">
<a href="javascript:void(0);" class="cart-item-remove" data-key="${itemKey}" data-up-quantity="0" >
<svg aria-hidden="true" data-prefix="fal" data-icon="times" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" class="svg-inline--fa fa-times fa-w-10 fa-2x"><path fill="currentColor" d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z" class=""></path></svg>
</a>
</div>
</div>
</li>`;

    });
    this.itemsContainer.innerHTML = itemHTML;
  }

}

const closeNotificatioPopup = () => {
  this.cartNotificationPopup = document.querySelector(".custom-model-main[data-cart-popup]");
  this.cartNotificationPopup.classList.remove("model-open");
  this.cartNotificationPopup.classList.add("model-close");
}

const attachEvents = () => {
  this.cartNotificationPopup.querySelectorAll(".cart-qty-minus").forEach((minusBtn) => minusBtn.addEventListener('click', changeQuantity));
  this.cartNotificationPopup.querySelectorAll(".cart-qty-plus").forEach((plusBtn) => plusBtn.addEventListener('click', changeQuantity));
  this.cartNotificationPopup.querySelectorAll(".cart-item-remove").forEach((removeBtn) => removeBtn.addEventListener('click', changeQuantity));
  this.cartNotificationPopup.querySelector(".btn-actions .continue-shopping").addEventListener("click", closeNotificatioPopup);
  document.querySelector(".cart-popup-overlay").addEventListener("click", closeNotificatioPopup);
}

const changeQuantity = (event) => {
  this.cartNotificationPopup = document.querySelector(".custom-model-main[data-cart-popup]");
  this.button = event.currentTarget;
  this.loader = this.cartNotificationPopup.querySelector(".loading-cart-modal");
  this.loader.style.display = "block";
  let itemKey = this.button.dataset.key;
  let itemQuantity = this.button.dataset.upQuantity;
  let item = {
    id: itemKey,
    quantity: itemQuantity
  }
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Accept': 'application/json, text/plain, */*',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(item)
  }).then((res) => { return res.json() })
  .then((response) => {
    showCartNotification();
    this.loader.style.display = "none";
  })
  .catch((error) => {
    console.error('Error:', error);
    return false;
  });
}